import React, {useCallback} from 'react';
import { Button, Tooltip, Modal, notification } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import {deleteProperty} from "../../../redux/api/documents/propertiesThunks";
import {useAppDispatch} from "../../../redux/hooks";
import {PropertyFull} from "../../../types";

export interface DeletePropertyActionProps {
    property: PropertyFull;
}

const DeletePropertyAction: React.FC<DeletePropertyActionProps> = ({ property }) => {
    const dispatch = useAppDispatch();

    const handleDelete = useCallback(() => {
        Modal.confirm({
            title: 'Вы уверены, что хотите удалить это свойство?',
            okText: 'Удалить',
            cancelText: 'Отмена',
            async onOk() {
                try {
                    await dispatch(
                        deleteProperty({
                            propertyId: property.id,
                            documentId: property.documentId,
                        })
                    );
                    notification.success({ message: 'Свойство удалено' });
                } catch (error: any) {
                    notification.error({
                        message: 'Ошибка при удалении свойства',
                        description: error.message || 'Не удалось удалить свойство.',
                    });
                }
            },
        });
    }, [dispatch, property]);

    return (
        <Tooltip title="Удалить">
            <Button icon={<DeleteOutlined />} onClick={handleDelete} danger />
        </Tooltip>
    );
};

export default React.memo(DeletePropertyAction);
